(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["km-cardigan-style"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
  const input = event.target;
  if (!input.matches('input[type="radio"], select')) return;
  const name = input.name.trim();
  if (name !== 'Size' && !name.startsWith('Size-') && name !== 'options[Size]') return;
  document.querySelectorAll('[data-km-size-variants]').forEach(function(link) {
    const sizes = JSON.parse(link.dataset.kmSizeVariants);
    const variantId = sizes[input.value];
    if (!variantId) return;
    const target = new URL(link.href, window.location.origin);
    target.searchParams.set('variant', String(variantId));
    link.href = target.toString();
  });
});
  } catch(e) { console.error(e); }
})();

})();
